import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

const CourseListPage = lazy(() => import('./pages/list'));
const CourseNewPage = lazy(() => import('./pages/new'));
const CourseEditPage = lazy(() => import('./pages/edit'));
const LessonEditorPage = lazy(() => import('./pages/LessonEditorPage'));
const CourseStudentsPage = lazy(() => import('./pages/students'));
const StudentDetailPage = lazy(() => import('./pages/student-detail'));

/**
 * Маршруты для курсов V1 (упрощенная версия)
 * 
 * Базовые роуты без сложных вложенностей
 */
export const courseRoutesV1 = {
    path: 'courses',
    element: <Outlet />,
    children: [
        { element: <CourseListPage />, index: true },
        { path: 'new', element: <CourseNewPage /> },
        { path: ':id/edit', element: <CourseEditPage /> },
        { path: ':id/students', element: <CourseStudentsPage /> },
        { path: ':id/students/:studentId', element: <StudentDetailPage /> },
        { path: ':id/lesson/:lessonId/edit', element: <LessonEditorPage /> },
    ],
};
